// Collector endpoints (plan 5.1.1, 4.6.4, D-005): OTLP/HTTP logs·metrics (JSON or protobuf, gzip/deflate), traces
// accepted and only counted. Token header `x-aiax-hub-token` (axh_ing_…) is checked before the body is read.
// Responses follow OTLP: partial success per record; errors are OTLP `Status` bodies (not the /api error envelope).
import { z } from 'zod';
import { COLLECT_TOKEN_HEADER, TOKEN_PREFIX } from '../enums.js';

export const OTLP_PATHS = { logs: '/otlp/v1/logs', metrics: '/otlp/v1/metrics', traces: '/otlp/v1/traces' } as const;
export const OTLP_CONTENT_TYPES = ['application/json', 'application/x-protobuf'] as const;

export const IngestHeaders = z.object({
  [COLLECT_TOKEN_HEADER]: z.string().startsWith(TOKEN_PREFIX.collect).max(200),
  'content-type': z.string().refine((v) => OTLP_CONTENT_TYPES.some((t) => v.startsWith(t)), 'unsupported content type'),
  'content-encoding': z.enum(['gzip', 'deflate', 'identity']).optional(),
});

/** Body is parsed by packages/otlp-proto (64-bit safe); the contract only marks it as an OTLP export request. */
export const OtlpExportRequest = z.looseObject({});

/** int64 counters may arrive as JSON strings (OTLP JSON mapping). */
const Int64 = z.union([z.int().nonnegative(), z.string().regex(/^\d+$/)]);
export const OtlpLogsResponse = z.object({ partialSuccess: z.object({ rejectedLogRecords: Int64, errorMessage: z.string() }).optional() });
export const OtlpMetricsResponse = z.object({ partialSuccess: z.object({ rejectedDataPoints: Int64, errorMessage: z.string() }).optional() });
export const OtlpTracesResponse = z.object({ partialSuccess: z.object({ rejectedSpans: Int64, errorMessage: z.string() }).optional() });

/**
 * Error body (google.rpc.Status JSON). HTTP: 400 malformed · 401 missing/unknown/expired/revoked token or old PoC
 * header (counted as "old settings") · 413 too large · 415 content type · 429 per-token limit · 503 + Retry-After when
 * the queue is full or storage fails.
 */
export const OtlpStatus = z.object({ code: z.int(), message: z.string().max(300), details: z.array(z.unknown()).optional() });

export const ingestSchemas = { IngestHeaders, OtlpExportRequest, OtlpLogsResponse, OtlpMetricsResponse, OtlpTracesResponse, OtlpStatus } as const;
